import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

@Component({
  selector: 'acs-expand-button',
  imports: [MatIcon, TranslatePipe],
  templateUrl: './expand-button.component.html',
  styleUrl: `./expand-button.component.scss`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExpandButtonComponent {
  @Input() disabled: boolean = false;
  @Input() expanded: boolean = false;
  @Output() expandClick = new EventEmitter<Event>();
}
